import type { Periodo } from '@/lib/supabase/tipos-bd'
import { correrDia, nombreDelPeriodo } from '@/modules/tablero/periodo/cifras'
import { hoy } from '@/modules/tablero/semana'

import estilos from './PaginaAuditoria.module.css'

/**
 * Semana | Mes | Año con ‹ › y «Hoy», como en el tablero, para que «esta
 * semana» sea la misma en todas las pantallas.
 */
const PERIODOS: [Periodo, string][] = [
  ['semana', 'Semana'],
  ['mes', 'Mes'],
  ['año', 'Año'],
]

export function SelectorDePeriodo({
  periodo,
  desde,
  hasta,
  onPeriodo,
  onFecha,
}: {
  periodo: Periodo
  desde: string
  hasta: string
  onPeriodo: (p: Periodo) => void
  onFecha: (f: string) => void
}) {
  const enCurso = desde <= hoy() && hoy() <= hasta

  return (
    <div className={estilos.periodo}>
      <div className={estilos.segmentos} role="group" aria-label="Periodo">
        {PERIODOS.map(([valor, texto]) => (
          <button
            key={valor}
            type="button"
            className={periodo === valor ? estilos.segmentoVivo : undefined}
            aria-pressed={periodo === valor}
            onClick={() => onPeriodo(valor)}
          >
            {texto}
          </button>
        ))}
      </div>
      <div className={estilos.navegador} role="group" aria-label="Elegir periodo">
        <button
          type="button"
          className={estilos.flecha}
          onClick={() => onFecha(correrDia(desde, -1))}
          aria-label="Periodo anterior"
        >
          ‹
        </button>
        <span className={estilos.rango}>
          {nombreDelPeriodo(periodo, desde, hasta)}
          {enCurso && <span className={estilos.enCurso}>en curso</span>}
        </span>
        <button
          type="button"
          className={estilos.flecha}
          onClick={() => onFecha(correrDia(hasta, 1))}
          disabled={enCurso}
          aria-label="Periodo siguiente"
        >
          ›
        </button>
        {!enCurso && (
          <button type="button" className={estilos.hoy} onClick={() => onFecha(hoy())}>
            Hoy
          </button>
        )}
      </div>
    </div>
  )
}
